<template>
  <div
    v-if="userTrail"
    :class="$style.trailResume"
    :style="`--trailColor: ${userTrail.color}`"
  >
    <router-link :to="{ name: 'trail.my' }" :class="$style.trailResume__inner">
      <div :class="$style.trailResume__label1">Continue sua jornada na trilha de</div>
      <div :class="$style.trailResume__label2">{{ userTrail.name }}</div>
  
      <div :class="$style.trailResume__progress">
        <BaseProgressBar :value="userTrail.trail_attended_percent"/>
      </div>
    </router-link>
  </div>
</template>

<script>
import BaseProgressBar from '@/components/progressbar/BaseProgressBar'
import { useUserTrail } from './trail'

export default {
  name: 'TrailResume',

  components: {
    BaseProgressBar,
  },

  setup () {
    const { userTrail } = useUserTrail()

    return { userTrail }
  }
}
</script>

<style lang="scss" scoped module>
@import "~@/components/trail/trail.scss";

.trailResume {
  text-align: center;
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 100;

  &__inner {
    display: inline-block;
    border-bottom: 2px solid var(--trailColor);
    background-color: #fff;
    color: rgba(#000, .75);
    padding: 1rem;
    box-shadow: 0 2px 5px var(--trailColor);
    text-align: center;
    border-radius: 8px;
    font-family: 'Poppins';
  }

  &__progress {
    margin: 16px auto 0;
  }

  &__label1 {
    font-size: 0.9375rem;
  }

  &__label2 {
    font-weight: 700;
  }

  @media (max-width: 550px) {
    position: relative;
    inset: auto;
    margin-top: 32px;
    padding: 0 15px;
    
    &__inner {
      display: block;
      box-shadow: 0 0 0;
      border-radius: 0;
      border: 1px solid var(--trailColor);
      border-left: 3px solid var(--trailColor);
      border-radius: 8px;;
    }
  }
}
</style>